enum ArcgisIntegrationStatus {
  active = 'active',
  archived = 'archived',
}

export default ArcgisIntegrationStatus
